export default "/assets/site/images/vizisport.jpg?5417b41e821d6e50d1111c657f185697";